module.exports = __webpack_public_path__ + "img/spreadsheets.e3f3b816.jpg";